import UpcomingEventsActions from "@redux/feature/SalesHome/action/upcomingEvents";
import UpcomingMeetingsActions from "@redux/feature/SalesHome/action/upcomingMeetings";
import ExpiringLeadsActions from "@redux/feature/SalesHome/action/expiringLeads";
import EngagementDashboardActions from "@redux/feature/SalesHome/action/engagementDashboard";
import EngagementDashbardStatusActions from "@redux/feature/SalesHome/action/engagementDashboardStatus";
export default (function () {
    return {
        eventActivities: {
            upcomingEvents: new UpcomingEventsActions(),
            upcomingMeetings: new UpcomingMeetingsActions(),
            expiringLeads: new ExpiringLeadsActions(),
        },
        engagementDashboard: new EngagementDashboardActions(),
        engagementDashboardStatus: new EngagementDashbardStatusActions(),
    };
});
